import CurrentActivity from "./current-activity";

const Offers: React.FC = () => {
  return (
    <div>
      <div className="mt-1">
        <h3 className="text-[22px] font-normal text-[#1E2F65]">
          Activity Calendar
        </h3>
        <CurrentActivity />
      </div>
    </div>
  );
};

export default Offers;
